class ChooseSize extends HTMLElement {
  constructor() {
    super();
    this.openClass = 'state--active';
    this.onDocumentClick = this.onDocumentClick.bind(this);
  }

  connectedCallback() {
    if (this.initialized) {
      this.addDocumentClickListener();
      return;
    }

    this.button = this.querySelector('.choose-size__button');
    this.dropdown = this.querySelector('.choose-size__dropdown');
    this.addButton = this.querySelector('.choose-size__add-button');
    this.addButtonPrice = this.addButton && this.addButton.querySelector('.choose-size__price');

    if (!this.button || !this.dropdown || !this.addButton) return;

    this.setIds();
    this.setExpanded(false);
    this.initialized = true;

    this.button.addEventListener('click', (event) => this.onButtonClick(event));
    this.addButton.addEventListener('click', (event) => this.onAddButtonClick(event));
    this.addEventListener('change', (event) => this.onRadioChange(event));
    this.addEventListener('keydown', (event) => this.onKeyDown(event));
    this.addDocumentClickListener();
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick, true);
    this.documentClickListening = false;
  }

  addDocumentClickListener() {
    if (this.documentClickListening) return;
    document.addEventListener('click', this.onDocumentClick, true);
    this.documentClickListening = true;
  }

  setIds() {
    ChooseSize.count = (ChooseSize.count || 0) + 1;
    const id = `choose-size-${ChooseSize.count}`;
    this.button.id = `${id}-button`;
    this.dropdown.id = `${id}-dropdown`;
    this.button.setAttribute('aria-controls', this.dropdown.id);
    this.dropdown.setAttribute('aria-labelledby', this.button.id);
    this.querySelectorAll('.choose-size__radio').forEach((radio, index) => {
      const label = radio.nextElementSibling;
      radio.id = `${id}-radio-${index + 1}`;
      if (label) label.setAttribute('for', radio.id);
    });
  }

  setExpanded(expanded) {
    this.button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (expanded) {
      this.dropdown.hidden = false;
      this.dropdown.style.display = '';
    } else {
      this.dropdown.hidden = true;
      this.dropdown.style.display = 'none';
    }
  }

  onRadioChange(event) {
    if (!event.target.matches('.choose-size__radio')) return;
    this.addButton.removeAttribute('disabled');
    const price = event.target.getAttribute('data-price');
    if (price && this.addButtonPrice) this.addButtonPrice.innerHTML = price;
  }

  showList(options = {}) {
    this.classList.add(this.openClass);
    this.setExpanded(true);
    if (options.focusFirstRadio) {
      const radio = this.querySelector('.choose-size__radio:not([disabled])');
      if (radio) radio.focus();
    }
  }

  hideList(options = {}) {
    this.classList.remove(this.openClass);
    this.setExpanded(false);
    if (options.restoreFocus) this.button.focus();
  }

  hideAllLists() {
    document.querySelectorAll('choose-size').forEach((el) => {
      if (typeof el.hideList === 'function') el.hideList();
    });
  }

  onDocumentClick(event) {
    if (this.dropdown.contains(event.target) || this.button.contains(event.target)) return;
    this.hideList();
  }

  onAddButtonClick(event) {
    event.preventDefault();
    const checked = this.querySelector('.choose-size__radio:checked');
    if (!checked || this.addButton.classList.contains('loading')) return;
    if (typeof window.addToCart !== 'function') return;

    this.addButton.classList.add('loading');
    const id = checked.value;
    window
      .addToCart(id, 1, {}, () => {
        document.dispatchEvent(new CustomEvent('addtocart'));
        this.addButton.classList.remove('loading');
        this.hideList();
      })
      .catch((error) => {
        console.error(error);
        this.addButton.classList.remove('loading');
      });
  }

  onKeyDown(event) {
    if (event.code === 'Escape') {
      event.preventDefault();
      this.hideList({ restoreFocus: true });
      return;
    }
    if (event.target === this.button && (event.code === 'Enter' || event.code === 'Space')) {
      this.openWithKeyboard = true;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    if (this.classList.contains(this.openClass)) {
      this.hideList();
      this.openWithKeyboard = false;
      return;
    }
    this.hideAllLists();
    this.showList({ focusFirstRadio: this.openWithKeyboard });
    this.openWithKeyboard = false;
  }
}

customElements.define('choose-size', ChooseSize);
